export const fuelTypeEnum = [
  { id: 'GASOLINE', label: 'Benzín' },
  { id: 'OIL', label: 'Nafta' },
  { id: 'LPG', label: 'LPG' },
  { id: 'BIO_OIL', label: 'Bionafta' }
];

export const educationTypeEnum = [
  { id: 'NO_ABITUR', label: 'Střední bez maturity' },
  { id: 'ABITUR', label: 'Střední s maturitou' },
  { id: 'PROFESSIONS', label: 'Vyšší odborné' },
  { id: 'UNIVERSITY', label: 'Vysokoškolské' }
];



// WEBPACK FOOTER //
// ./src/modules/dictionary/_dictionaryEnums.ts